import type { LifecycleStatus } from '@/entities/lot/model/lifecycleStatus'

export interface LotDetailVisibilityCheckboxState {
  hideExpiredLots: boolean
  hideRetiredLots: boolean
}

export interface LotDetailRowForVisibilityFiltering {
  id: number
  lifecycleStatus: LifecycleStatus
}

/**
 * The Choose Supply picker and the instrument Supplies tab both open with expired and retired
 * supplies hidden (REBUILD-354): neither can be selected, so listing them by default buries the ones
 * that can. The active selection is exempt from both filters, so hiding them never hides the supply
 * the task is currently on.
 */
export const DEFAULT_LOT_DETAIL_VISIBILITY: LotDetailVisibilityCheckboxState = {
  hideExpiredLots: true,
  hideRetiredLots: true,
}

/** Uses server-derived `lifecycleStatus` (parity with serializers). */
export const lotDetailPassesVisibilityFilters = (
  lotDetailRow: LotDetailRowForVisibilityFiltering,
  checkboxState: LotDetailVisibilityCheckboxState,
  alwaysVisibleLotDetailIds: readonly number[],
): boolean => {
  if (alwaysVisibleLotDetailIds.includes(lotDetailRow.id)) return true

  if (checkboxState.hideExpiredLots && lotDetailRow.lifecycleStatus === 'expired') return false

  if (checkboxState.hideRetiredLots && lotDetailRow.lifecycleStatus === 'retired') return false

  return true
}
